import { DenormalizedBulkOrder } from '@packages/types'
import React from 'react'
import tinycolor from 'tinycolor2'

import { DenormalizedBulkOrderRow } from 'customizer/bulkOrder/reducer'
import { isBulkOrderTotalQuantityEqualOrMoreThanMaxSelector } from 'customizer/bulkOrder/selectors'
import { useSelector } from 'customizer/hooks'
import { disablePersonalisationsSelector } from 'customizer/questionPanel/selectors'
import useThemeSettings from 'customizer/theme/useThemeSettings'
import { getDisabledColor } from 'customizer/theme/utils'
import BulkOrderAddRowButton from 'themes/common/components/bulkOrder/BulkOrderAddRowButton'
import BulkOrderTotal from 'themes/common/components/bulkOrder/BulkOrderTotal'
import CommonBulkOrderList from 'themes/common/components/bulkOrder/questionPanel/list/BulkOrderList'
import BulkOrderListFooter from 'themes/common/components/bulkOrder/questionPanel/list/BulkOrderListFooter'

import BulkOrderRowForm from './BulkOrderRowForm'

import './BulkOrderList.scss'
export interface BulkOrderListProps {
  bulkOrderGroup: DenormalizedBulkOrder
  rows: DenormalizedBulkOrderRow[]
  showTopBorder?: boolean
}

const BulkOrderList = ({ bulkOrderGroup, rows, showTopBorder }: BulkOrderListProps) => {
  const bulkOrderStyle = useThemeSettings('bulkOrder')
  const actionSectionStyle = useThemeSettings('actionSection')

  const isBulkOrderTotalQuantityEqualOrMoreThanMax = useSelector(isBulkOrderTotalQuantityEqualOrMoreThanMaxSelector)
  const disablePersonalisations = useSelector(disablePersonalisationsSelector)

  return (
    <>
      <CommonBulkOrderList
        rows={rows}
        showEyeWhenOpened
        borderColor={bulkOrderStyle.listElementDividerColor}
        openedBorderColor={tinycolor(bulkOrderStyle.listElementDividerColor).setAlpha(0.08).toHex8String()}
        renderRowForm={(row, index) => (
          <BulkOrderRowForm key={row.id} row={row} rowIndex={index} bulkOrderGroup={bulkOrderGroup} rows={rows} />
        )}
      />

      <BulkOrderListFooter bulkOrderGroup={bulkOrderGroup} showTopBorder={showTopBorder}>
        <BulkOrderAddRowButton
          bulkOrderGroup={bulkOrderGroup}
          disabled={isBulkOrderTotalQuantityEqualOrMoreThanMax}
          isEditingStartingPoint={disablePersonalisations}
          style={{
            borderColor: bulkOrderStyle.buttonBorderColor,
            borderWidth: bulkOrderStyle.buttonBorderThickness,
            color: isBulkOrderTotalQuantityEqualOrMoreThanMax
              ? getDisabledColor(bulkOrderStyle.buttonTextColor)
              : bulkOrderStyle.buttonTextColor,
            borderRadius: bulkOrderStyle.buttonRounding || actionSectionStyle.buttonsBorderRadius,
            fontFamily: actionSectionStyle.fontFamily?.fontFamily,
          }}
          iconStyle={{
            fill: isBulkOrderTotalQuantityEqualOrMoreThanMax
              ? getDisabledColor(bulkOrderStyle.buttonTextColor)
              : bulkOrderStyle.buttonTextColor,
          }}
        />

        <BulkOrderTotal />
      </BulkOrderListFooter>
    </>
  )
}

export default BulkOrderList
